function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Children, cloneElement } from 'react';
import { Box, Text } from 'grommet';
import { withTheme } from 'styled-components';
const CustomFormField = ({
  label,
  name,
  help,
  error,
  theme,
  children,
  ...rest
}) => {
  const {
    formField
  } = theme;
  const borderColor = theme.global.colors['status-error'];
  const normalizedChildren = children ? Children.map(children, child => {
    if (child) {
      return /*#__PURE__*/cloneElement(child, {
        style: {
          borderColor: error ? borderColor : null
        },
        error
      });
    }
    return child;
  }) : null;
  return /*#__PURE__*/React.createElement(Box, _extends({
    margin: {
      ...formField.margin
    }
  }, rest), /*#__PURE__*/React.createElement(Text, _extends({
    as: "label",
    htmlFor: name,
    size: "small"
  }, formField.label), label), help && /*#__PURE__*/React.createElement(Text, _extends({}, formField.help, {
    color: formField.help.color[theme.dark ? 'dark' : 'light']
  }), help), normalizedChildren, error && /*#__PURE__*/React.createElement(Text, _extends({}, formField.error, {
    color: formField.error.color[theme.dark ? 'dark' : 'light']
  }), error));
};
export default withTheme(CustomFormField);